import { Component, OnInit, HostListener, forwardRef, Output, EventEmitter } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { LovDataService } from '../../services/lov-data/lov-data.service';

@Component({
  selector: 'app-countries-dropdown-input',
  templateUrl: './countries-dropdown-input.component.html',
  styleUrls: ['./countries-dropdown-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CountriesDropdownInputComponent),
      multi: true,
    },
  ],
})
export class CountriesDropdownInputComponent
  implements OnInit, ControlValueAccessor {
  listOfCounties: any[] = [];
  filteredCountries: any[] = [];
  selectedCountry: any = null;
  searchQuery: string = '';
  isDropdownVisible: boolean = false;

  @Output() selected = new EventEmitter<any>();  // Emit selected country name

  onChange = (value: any) => { };
  onTouched = () => { };

  constructor(private _lovDataService: LovDataService) { }

  ngOnInit() {
  }

  toggleDropdown(event: MouseEvent) {
    event.stopPropagation();
    this.isDropdownVisible = !this.isDropdownVisible;
  }

  filterCountries() {
    const query = this.searchQuery.toLowerCase();
    this.filteredCountries = this.listOfCounties.filter((country) =>
      country.name.toLowerCase().includes(query)
    );
  }

  selectCountry(country: any) {
    this.selectedCountry = country;
    this.isDropdownVisible = false;
    this.searchQuery = '';
    this.filterCountries();
    this.selected.emit(this.selectedCountry);  // Emit country name

    // Notify Angular forms of the change
    this.onChange(this.selectedCountry);
    this.onTouched();
  }

  @HostListener('document:click', ['$event'])
  handleOutsideClick(event: MouseEvent) {
    this.isDropdownVisible = false;
  }

  // ControlValueAccessor methods
  writeValue(value: any): void {
    this._lovDataService.GetCountries().subscribe((response) => {
      this.listOfCounties = response.countries;
      this.filteredCountries = [...this.listOfCounties];

      if (value) {
        this.selectedCountry = this.listOfCounties.find(
          (country) => country.name.toLowerCase() === value?.toLowerCase()
        );        
      } else {
        this.selectedCountry = null;
      }
      this.onChange(this.selectedCountry);
      this.onTouched();
    });
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    // Optionally handle the disabled state
  }
}
